import { state } from './state';
import { MessagingModule } from './MessagingModule';
import { ErrorModal } from './components/ErrorModal';


export { MessagingTypes, isInfoError, getErrorData } from './state';
export * from './state/actions';
export { withErrorHandler, withHideModal } from './state/sagas';

export { modalClassNames, ModalContext, withModalContext, createModal, useModalContext } from './components/Modal/utils';
export type { MessagingProps } from './components/Messaging/types';
export type { ModalComponentProps } from './components/Modal/types';
export { connector } from './state';

export const messaging = {
    messaging: {
        modalTypes: {
            ErrorModal,
        },
    },
    state,
    renderChain: [
        [MessagingModule, 40],
    ],
};
